import axios from 'axios'
export const getKuaiXun = (params) => axios({
    methods: 'get',
    url: '/nbd-app-php-h5/competition_Player/getKuaixunZt'
})
export const getTopNews = (params) => axios({
    method: 'get',
    url: 'https://www.nbd.com.cn/columns/1907/display_top_articles_of_column.json',
})
export const getRank = (params) => axios({
    method: "get",
    url: "/nbd-app-php-h5/competition_Player/getRank",
    params: {
        rank: 3,
        rankType: 5,
    }
})
export const getinfo = (params) => axios({
    method: "get",
    url: "/nbd-app-php-h5/competition_User/getInfo",
    params: {
        app_token: '',
        chiguNum: 3,
    }
})